// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:460px){#ButtonCancel{-webkit-box-flex:.5;-ms-flex:.5;flex:.5;text-align:center;-ms-flex-pack:center}#ButtonCancel,.button--primary{-webkit-box-pack:center;justify-content:center}.button--primary{-webkit-box-flex:2;-ms-flex:2;flex:2;-ms-flex-pack:center}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
